<div class="login">
  <div class="login-wrapper">
    <div class="header-form">
      <div class="logo-box">
        <img src="assets/img/logo-mini.svg" class="logo" alt="">
      </div>
      <div class="header-form__caption">
        <div class="title">Помощь и инструкции</div>
      </div>
    </div>
    <h2>Инструкции:</h2>
    <ul class="list-action">
      <li class="item"><a routerLink="." fragment="reg">Регистрация пользователя</a></li>
      <li class="item"><a routerLink="." fragment="required">Обращение в Своя Связь</a></li>
      <li class="item"><a routerLink="." fragment="restore">Восстановление пароля</a></li>
      <li class="item"><a routerLink="." fragment="added">Добавить новый контакт</a></li>
      <li class="item"><a routerLink="." fragment="send">Отправка Сообщений</a></li>
      <li class="item"><a routerLink="." fragment="video">Видеозвонок</a></li>
    </ul>
    <ul class="list">
      <li class="item" id="reg">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Регистрация пользователя</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="description">
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Перейдите на страницу входа в личный кабинет и нажмите на пункт <a routerLink="/registration"><strong>Регистрация</strong></a></li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-reg.png')">
                  <img class="gallery-image" src="/assets/img/help-reg.png" alt="Переход на страницу регистрации со страницы авторизации">
                </div>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Заполните все поля и нажмите кнопку <strong>Зарегистрироваться</strong></li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-reg2.png')">
                  <img class="gallery-image" src="/assets/img/help-reg2.png" alt="Процесс регистрации">
                </div>
                <div class="message message--alert">
                  <p><strong>Обращаем ваше внимание!</strong> Чтобы успешно пройти регистрацию у вас должна быть постоянная карта абонента СвояСвязь. Если вы заполняли анкету и у вас есть постоянная карта, но при этом регистрация не проходит, напишите нам обращение. В теме обращения укажите Регистрация, в описании укажите номер вашей карты, Имя и Фамилию. В кратчайшие сроки мы устраним проблему.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>


      <li class="item" id="required">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Обращение в Своя Связь</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-request.png')">
                <img class="gallery-image" src="/assets/img/help-request.png" alt="Обращение в Своя Связь">
              </div>
              <div class="description">
              </div>
            </div>
          </div>
        </div>
      </li>

      <li class="item" id="restore">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Восстановление пароля</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="description">
                <p>Если вы не помните пароль от личного кабинета, для создания нового пароля для входа обратитесь в воспитательный отдел вашего учреждения.</p>
              </div>
            </div>
          </div>
        </div>
      </li>


      <li class="item" id="added">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Добавить новый контакт</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="description">
                <p>Чтобы начать общение через видеозвонки или письма, добавьте новый контакт</p>
                <div class="message message--alert">
                  <p><strong>Обращаем ваше внимание!</strong> Чтобы добавить контакт, абонент должен быть зарегистрирован в системе СвояСвязь. Перед добавлением контакта, уточните прошёл ли пользователь регистрацию. Если пользователь не зарегистрирован в системе, вы можете отправить ему приглашение в виде СМС.</p>
                </div>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Нажмите на кнопку <strong>Добавить контакт</strong></li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-add-contact.png')">
                  <img class="gallery-image" src="/assets/img/help-add-contact.png" alt="Процесс добавление нового контакта, кнопка добавить контакт">
                </div>

                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>В окне добавления контакта введите номер телефона абонента которого хотите добавить в свой список контактов</li>
                </ul>

                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-add-contact2.png')">
                  <img class="gallery-image" src="/assets/img/help-add-contact2.png" alt="Процесс добавление нового контакта">
                </div>

                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Если пользователь зарегистрирован в системе СвояСвязь, он будет успешно добавлен в ваш список контактов</li>
                  <li class="road-map__item"><div class="point"></div>Если пользователь не зарегистрирован в системе СвояСвязь, то вам будет предложено отправить приглашение пользователю в виде СМС. Пользователь получит СМС с короткого номера <strong>svoyasvazru</strong> в виде ссылки для регистрации</li>
                </ul>

                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-add-contact3.png')">
                  <img class="gallery-image" src="/assets/img/help-add-contact3.png" alt="Процесс добавление нового контакта">
                </div>

                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>После отправки приглашения абонент появится в вашем списке контактов, начать общение можно после успешной регистрации пользователя в системе СвояСвязь.</li>
                  <li class="road-map__item"><div class="point"></div>Вы можете повторно отправить приглашение по СМС через <strong>3 дня</strong></li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="item" id="send">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Отправка Сообщений</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="description">
                <p>Вы можете воспользоваться сервисом отправки сообщение абоненту, для этого:</p>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Выберите нужный контакт из списка контактов</li>
                  <li class="road-map__item"><div class="point"></div>Напишите текст сообщения и нажмите кнопку <strong>Отправить</strong></li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-message.png')">
                  <img class="gallery-image" src="/assets/img/help-message.png" alt="Процесс отправки сообщений">
                </div>
                <p>После проверки системой цензурирования, абонент получит ваши сообщения и сообщения в чате сменит статус с <strong>“на модерации”</strong> на <strong>“доставлено”</strong></p>
                <p>После прочтения сообщений абонентом сообщения в чате сменит статус с <strong>“доставлено”</strong> на <strong>“прочитано”</strong></p>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="item" id="video">
        <div class="item__wrapper">
          <div class="item__head">
            <div class="item-head__wrapper">
              <h2 class="caption">Видеозвонок</h2>
            </div>
          </div>
          <div class="item__body">
            <div class="item-body__wrapper">
              <div class="description">
                <p>Вы можете воспользоваться сервисом видеозвонок абоненту, для этого:</p>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Договоритесь с абонентом о дате и времени видеозвонка</li>
                  <li class="road-map__item"><div class="point"></div>Зайдите в Личный Кабинет</li>
                  <li class="road-map__item"><div class="point"></div>Убедитесь что абонент в сети (Зеленый кружок около инициалов в списке контактов)</li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-status-online.png')">
                  <img class="gallery-image" src="/assets/img/help-status-online.png" alt="Индикатор онлайна пользователя">
                </div>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Нажмите на значок вызова в правом верхнем углу диалога</li>
                </ul>
                <div class="gallery-content" (click)="openGalleryModeration('/assets/img/help-call.png')">
                  <img class="gallery-image" src="/assets/img/help-call.png" alt="Местонахождение иконки вызова">
                </div>
                <ul class="road-map">
                  <li class="road-map__item"><div class="point"></div>Любая сторона может завершить вызов для окончания звонка</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
